import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash"

export class PlanningLeftoverTooltipCtrl implements IController {

  job: any;

  public warnings: any[];

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    this.warnings = [];
    _.forEach(this.job.stops, (s) => {
      this.warnings = this.warnings.concat(s.warnings || [])
    })
  }

  $onChanges(onChangesObj: angular.IOnChangesObject) {
    if (onChangesObj.job && !onChangesObj.job.isFirstChange()) {
      this.$onInit();
    }
  }
}


angular
  .module('bringoz.admin.planning')
  .component('planningLeftoverTooltip', {
    bindings: {
      job: '<',
    },
    template: require('./planning-leftover-tooltip.html').default,
    controller: PlanningLeftoverTooltipCtrl
  });
